import React, { useEffect, useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ClockIcon } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <section className="py-8 bg-red-600 text-white" data-id="element-73">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-74">
        <FadeIn data-id="element-75">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-76">
            <ClockIcon className="w-7 h-7 animate-pulse" data-id="element-77" />
            <h2 className="text-2xl md:text-3xl font-bold font-heading uppercase tracking-wider" data-id="element-78">
              OFERTA SOLO POR HOY !!!
            </h2>
          </div>

          <p className="text-base md:text-lg text-red-100 mb-5 max-w-2xl mx-auto" data-id="element-79">
            Reserva válida por <strong data-id="element-80">15 minutos</strong>. Si no accedés, tu
            descuento pasa a la siguiente persona.
          </p>

          <div className="inline-flex items-center justify-center gap-3 bg-white text-navy-900 px-6 py-3 rounded-xl shadow-2xl" data-id="element-81">
            <div className="flex flex-col items-center" data-id="element-82">
              <span className="text-4xl md:text-5xl font-bold font-heading tabular-nums leading-none" data-id="element-83">
                {String(minutes).padStart(2, '0')}
              </span>
              <span className="text-[10px] font-bold uppercase tracking-widest text-gray-500 mt-0.5" data-id="element-84">
                Minutos
              </span>
            </div>
            <span className="text-4xl md:text-5xl font-bold text-red-600 pb-4" data-id="element-85">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-86">
              <span className="text-4xl md:text-5xl font-bold font-heading tabular-nums leading-none" data-id="element-87">
                {String(seconds).padStart(2, '0')}
              </span>
              <span className="text-[10px] font-bold uppercase tracking-widest text-gray-500 mt-0.5" data-id="element-88">
                Segundos
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}